import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const fordproConfig: TSPConfig = {
  key: 'fordpro',
  name: 'FordPro',
  imageName: 'FordPro',
  category: TSPCategory.CREDENTIALS,
  helpText: 'Please input the ClientID and Client Secret from FordPro.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'ClientID',
          name: 'username',
          type: 'text',
          required: true,
        },
        {
          label: 'Client Secret',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default fordproConfig;
